import { styled } from "styled-components";

const PlaybooksListContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 10;
  overflow-y: auto;
  width: 100%;
  box-sizing: border-box;
`;

export default PlaybooksListContainer;
